import { AssessmentData } from "../../../pages/Assessments/services/stub-response";
import { QuestionData, TopicData } from "./stub-response";

export const getQuestionAPIresponse = async () => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        let _data = QuestionData;
        resolve(_data);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTopicAPIresponse = async () => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        let _data = TopicData;
        resolve(_data);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAssessmentByIdAPIresponse = async (id: string) => {
  try {
    const assessments = AssessmentData.assessments;
    const assessment = assessments.find((assessment) => assessment.id === id);
    return new Promise((resolve) => {
      setTimeout(() => resolve(assessment), 1000);
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const fetchTagsAPIresponse = async (query: string) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        const tags = [
          "React",
          "JavaScript",
          "TypeScript",
          "AI",
          "Machine Learning",
        ];

        resolve(tags);
      }, 1000);
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const fileUploadAPI = async (file: File) => {
  try {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log("File uploaded successfully:", file.name);
        resolve(file.name);
      }, 2000);
    });
  } catch (error) {
    return Promise.reject(error);
  }
};
